module.exports = __webpack_public_path__ + "img/attachment.bf59b3b5.png";